import React from "react";
import Pagination from "react-js-pagination";

import Footer from "../includes/Footer";
import Sidebar from "../includes/Sidebar";
import useSortableData from "../../../hooks/useSortableData";
import useTable from "../../../hooks/useTable";
import { useState } from "react";
import { useEffect } from "react";
import AdminListService from "../../../services/admin-list.service";

import { useSelector } from "react-redux";

import { toast } from "react-toastify";
import { useFormik } from "formik";

import Swal from "sweetalert2";
import * as XLSX from "xlsx";
import { ipAdd } from "../../../schema";
import moment from "moment";

export default function OktaUsers() {
  const state = useSelector((state) => state.stateVals);
  const { adminAccessToken } = state;

  const [loading, setLoading] = useState(false);
  const [tableData, settableData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);

  const [limit, setLimit] = useState("50");

  const usersList = async () => {
    setLoading(true);
    try {
      const responce = await AdminListService.listOktaUsers();

      const res = responce?.data?.data?.data || [];

      settableData(res);
      setFilteredData(res);

      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      settableData([]);
      setFilteredData([]);
    }
  };

  useEffect(() => {
    if (adminAccessToken) {
      usersList();
    }
  }, [adminAccessToken]);

  const handleSearch = (e) => {
    setLimit("50");

    const searchQuery = e.target?.value?.trim()?.toLowerCase();
    // Filter the data based on the search query
    if (searchQuery !== "") {
      const newFilteredData = tableData.filter((item) => {
        // Customize this condition based on your data structure and search requirements
        return (
          item?.email?.toString().toLowerCase().includes(searchQuery) ||
          item?.fname?.toString().toLowerCase().includes(searchQuery) ||
          item?.gers?.toString().toLowerCase().includes(searchQuery) ||
          item?.lname?.toString().toLowerCase().includes(searchQuery) ||
          item?.store_code?.toString().toLowerCase().includes(searchQuery) ||
          item?.region_code?.toString().toLowerCase().includes(searchQuery) ||
          item?.username?.toString().toLowerCase().includes(searchQuery) ||
          (item.lastactive &&
            moment(item.lastactive)
              .format("LLLL")
              ?.toString()
              .toLowerCase()
              .includes(searchQuery))
        );
      });

      setFilteredData(newFilteredData);
    } else {
      setFilteredData(tableData);
    }
  };
  const Table = ({ data, rowsPerPage }) => {
    const [page, setPage] = useState(1);
    const { slice } = useTable(data, page, rowsPerPage);
    const { items, requestSort, sortConfig } = useSortableData(slice);
    const getClassNamesFor = (name) => {
      if (!sortConfig) {
        return;
      }
      return sortConfig.key === name ? sortConfig.direction : undefined;
    };

    return (
      <div className="table-responsive mt-3">
        <table className="table table-striped table-bordered W-100 sort-ths">
          <thead>
            <tr>
              <th
                scope="col"
                onClick={() => requestSort("id")}
                className={getClassNamesFor("id")}
              >
                No.
              </th>
              <th
                scope="col"
                onClick={() => requestSort("gers")}
                className={getClassNamesFor("gers")}
              >
                GERS
              </th>{" "}
              <th
                scope="col"
                onClick={() => requestSort("store_code")}
                className={getClassNamesFor("store_code")}
              >
                Store Code
              </th>{" "}
              <th
                scope="col"
                onClick={() => requestSort("region_code")}
                className={getClassNamesFor("region_code")}
              >
                Region Code
              </th>{" "}
              <th
                scope="col"
                onClick={() => requestSort("username")}
                className={getClassNamesFor("username")}
              >
                Username
              </th>{" "}
              <th
                scope="col"
                onClick={() => requestSort("fname")}
                className={getClassNamesFor("fname")}
              >
                First Name
              </th>{" "}
              <th
                scope="col"
                onClick={() => requestSort("lname")}
                className={getClassNamesFor("lname")}
              >
                Last Name
              </th>{" "}
              <th
                scope="col"
                onClick={() => requestSort("email")}
                className={getClassNamesFor("email")}
              >
                Email
              </th>{" "}
              <th
                scope="col"
                onClick={() => requestSort("lastactive")}
                className={getClassNamesFor("lastactive")}
              >
                Last Active
              </th>
            </tr>
          </thead>
          <tbody>
            {items.length ? (
              items.map((el, index) => (
                <tr key={index}>
                  <td>
                    {page === 1 ? index + 1 : (page - 1) * limit + index + 1}
                  </td>
                  <td>{el.gers}</td>
                  <td>{el.store_code}</td>
                  <td>{el.region_code}</td>

                  <td>{el.username}</td>
                  <td>{el.fname}</td>
                  <td>{el.lname}</td>
                  <td>{el.email}</td>
                  <td>
                    {el.lastactive && moment(el.lastactive).format("LLLL")}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="text-center text-capitalize">
                  No record found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        {data.length && data.length > rowsPerPage ? (
          <Pagination
            activePage={page}
            itemsCountPerPage={parseInt(rowsPerPage)}
            totalItemsCount={data.length}
            onChange={(e) => {
              setPage(e);
            }}
            pageRangeDisplayed={8}
            itemClass="page-item"
            linkClass="page-link"
            firstPageText="First Page"
            lastPageText="Last Page"
          />
        ) : (
          ""
        )}
      </div>
    );
  };

  const exportRecord = async () => {
    const worksheet = XLSX.utils.json_to_sheet(
      filteredData?.map((data) => ({
        GERS: data?.gers || "",
        GERS: data?.gers || "",
        "Store Code": data?.store_code || "",
        "Region Code": data?.region_code || "",

        "Username	": data?.username || "",
        "First Name": data?.fname || "",
        "Last Name": data?.lname || "",

        Email: data?.email || "",
        "Last Active": data.lastactive
          ? moment(data.lastactive).format("LLLL")
          : "N/A",
      }))
    );
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
    XLSX.writeFile(
      workbook,
      `Okta Users Report ${moment(new Date()).format("lll")}.xlsx`
    );
  };
  return (
    <div className="wrapper">
      <main className="page-content customer-contnent">
        <div className="site-main-design">
          <Sidebar />

          <div className="card mt-4">
            <div className="card-header py-3">
              <h5 className="mb-0 font-22">
                Okta Users [{filteredData.length}]
                {tableData.length > 0 && (
                  <button
                    type="button"
                    onClick={exportRecord}
                    className="btn btn-primary d-inline-block float-end btn-sm"
                  >
                    Export All Users
                  </button>
                )}
              </h5>
            </div>

            <div className="card-body">
              <div className="clearfix"></div>
              <div className="row">
                <div className="col-md-3">
                  <select
                    className="form-select mt-2"
                    onChange={(e) => {
                      setLimit(e.target.value);
                    }}
                    value={limit}
                  >
                    <option value="50">50</option>
                    <option value="100">100</option>
                    <option value="500">500</option>
                    <option value="1000">1000</option>
                    <option value="1500">1500</option>
                    <option value={filteredData.length}>All</option>
                  </select>
                </div>
                <div className="col-md-6"></div>
                <div className="col-md-3">
                  <input
                    type="text"
                    onChange={handleSearch}
                    placeholder="Type to search"
                    className="form-control mt-2"
                  />
                </div>
              </div>
              <Table data={filteredData} rowsPerPage={limit} />
            </div>
          </div>
        </div>
      </main>
      <Footer />
      <div className={`loader ${loading ? "in" : ""}`}>
        <div className="spinner-border main-spin"></div>
      </div>
    </div>
  );
}
